export const styles = {
  fullWidth: {
    width: '100%',
  },
  button: {
    background: '#FFF',
    border: '1px solid #FF383C',
    padding: '14px 28px',
    borderRadius: '8px',
    '&:hover': {
      borderColor: '#D12D36',
      background: '#FFF',
    },
    '&:hover .delete-button-text': {
      color: '#D12D36',
    },
  },
  grid: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
  },
  text: {
    fontWeight: 400,
    fontSize: '14px',
    fontFamily: 'Inter',
    color: '#FF383C',
    textTransform: 'none',
  },
};
